<template>
  <div class="main-container">
    <div class="main-head-menu">
      <div class="options">
        <ul>
          <TechFilter
            :metroOptions="metroOptions"
            :skillOptions="skillOptions"
            :certificationOptions="certificationOptions"
            :levelOptions="levelOptions"
            :metroFilter="metroFilter"
            :certificationFilter="certificationFilter"
            :skillFilter="skillFilter"
            :levelFilter="levelFilter"
            :workTypeFilter="workTypeFilter"
            :notWorkTypeFilter="notWorkTypeFilter"
            :searchFilter="searchFilter"
            :workTypes="workTypes"
            :notWorkTypes="notWorkTypes"
            :verified="verified"
            :isActive="isActive"
            @buttonClick="onFilter"
          />
          <li>
            <a href="javascript:void(0);" @click="toPublic" title="Public">
              PUBLIC
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="addAll" title="Add All">
              ADD ALL
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="p-l" v-if="data">
          <div
            class="collapse available-techs"
            v-for="(techLevel, index) in Object.keys(data)"
            :key="index"
          >
            <div
              v-if="data[techLevel].length"
              class="collapse-title available-techs-title m-t"
              @click="toggleCollapse(techLevel)"
            >
              <i class="material-icons-outlined align-middle">{{
                levelstatus[techLevel] ? "arrow_drop_down" : "arrow_right"
              }}</i>
              {{ techLevel }}
              <span class="badge">{{ data[techLevel].length }}</span>
            </div>
            <div
              class="collapse-content flex flex-row flex-wrap"
              v-show="levelstatus[techLevel]"
            >
              <div
                class="main-pannel available-techs-panel flex-column"
                v-for="techData in data[techLevel]"
                :key="techData.id"
              >
                <div class="main-pannel-content flex-grow">
                  <div
                    class="tech-resume-info flex items-center justify-center"
                  >
                    <div class="flex-1">
                      <!-- <h3>{{(techData.name ? techData.name : techData.email) | getNameByEmail}}</h3> -->
                      <h3 v-if="user.roles.admin">
                        {{ techData.name }}
                      </h3>
                      <h3 v-if="!user.roles.admin">
                        {{ techData.name | getShorterName }}
                      </h3>
                      <img
                        v-if="techData.windows"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-windows.svg"
                        alt="windows"
                        class="os-icon"
                      />
                      <img
                        v-if="techData.mac"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-apple.svg"
                        alt="apple"
                        class="os-icon"
                      />
                      <img
                        v-if="techData.linux"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-linux.svg"
                        alt="linux"
                        class="os-icon"
                      />
                      <p>Location: {{ techData.metro }}</p>
                      <div>
                        <span
                          class="status-pill"
                          :class="{
                            red: !techData.is_active,
                            green: techData.is_active,
                          }"
                        ></span>
                        <span>{{
                          techData.is_active ? "Active" : "Inactive"
                        }}</span>
                        <div
                          v-if="techData.work_type"
                          class="available-techs-work-type"
                        >
                          {{ techData.work_type ? techData.work_type : "" }}
                        </div>
                      </div>
                    </div>
                    <div class="tech-resume-info-avatar">
                      <div class="tech-resume-info-avatar-container">
                        <span v-if="!techData.photo_url">{{
                          (techData.name ? techData.name : techData.email)
                            | getFirstLetter
                        }}</span>
                        <img v-else :src="techData.photo_url" alt />
                      </div>
                    </div>
                  </div>
                  <div class="dashboard-more-info">
                    <label>Title:</label>
                    <p>{{ techData.title ? techData.title : "none" }}</p>
                    <label>Rate:</label>
                    <p>
                      {{
                        techData.rate
                          ? techData.rate
                          : 0 | currencyFilter("$", 2)
                      }}
                    </p>
                    <label>Bio:</label>
                    <p class="available-techs-bio">
                      {{ techData.bio ? techData.bio : "none" }}
                    </p>
                    <label>Join Date:</label>
                    <p style="min-height: 24px">{{ techData.createdString }}</p>
                  </div>
                  <div v-if="techData.verified" class="verified-tag" />
                </div>
                <div class="main-pannel-foot">
                  <ul>
                    <li v-if="user && user.roles && user.roles.admin">
                      <a
                        href="javascript:void(0)"
                        @click="viewAsConsultant(techData)"
                        >View As</a
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          name: 'resume',
                          params: { id: techData.id, type: 'allinfo' },
                        }"
                        target="_blank"
                        >Resume</router-link
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onClickProject(techData)"
                        >Project</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelRequest
            v-if="editOpen == 1"
            :propsData="requestPropsData"
            :submitLoading="requestSubmitLoading"
            @buttonClick="onRequestButtonClick"
          ></PanelRequest>
          <PanelProject
            v-if="editOpen == 2"
            :projectOptions="projectOptions"
            :projectToRoles="projectToRoles"
            :submitLoading="projectSubmitLoading"
            :addType="addType"
            @buttonClick="onProjectButtonClick"
          ></PanelProject>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/vendor/firebase";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import PanelRequest from "@/components/client/clientAvailableTechs/PanelRequest.vue";
import PanelProject from "@/components/client/clientAvailableTechs/PanelProject.vue";
import * as database from "@/vendor/database";
import { httpGetNoToken, httpGet } from "@/http/http";
import moment from "moment-timezone";
import TechFilter from "@/components/TechFilter.vue";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      consultants: null,
      techLevels: null,
      levelstatus: null,
      data: null,
      metroOptions: [],
      metroItem: {
        text: "",
        value: "",
      },
      techLevelsSort: null,
      searchText: null,
      clientId: null,
      metroSearch: null,
      editOpen: false,
      requestPropsData: null,
      clientEmail: null,
      requestSubmitLoading: false,
      skillOptions: [],
      certificationOptions: [],
      projectOptions: [],
      projectToRoles: new Map(),
      projectSubmitLoading: false,
      levelOptions: [],
      metroFilter: null,
      certificationFilter: null,
      skillFilter: null,
      levelFilter: null,
      workTypeFilter: "",
      notWorkTypeFilter: "",
      workTypes: [],
      notWorkTypes: [],
      editConsultantId: null,
      addType: "one",
      searchFilter: "",
      verified: null,
      isActive: true,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    ModelSelect,
    EditPannel,
    OptionMenu,
    PanelRequest,
    PanelProject,
    TechFilter,
  },
  watch: {
    consultants: function () {
      this.updateData();
    },
    techLevels: function () {
      this.updateData();
    },
  },
  beforeMount() {
    // return;
    this.getUrlParams();
    this.bindData();
  },
  methods: {
    getUrlParams: function () {
      this.clientId = this.$route.query.id;
      if (this.clientId) {
        database.getDoc("companies", this.clientId).then((result) => {
          if (result.ok && result.data.data.email) {
            this.clientEmail = result.data.data.email;
          }
        });
      }
      const metro = this.$route.query.metro;
      if (metro && metro !== "all") {
        this.metroItem = {
          text: metro,
          value: metro,
        };
      } else {
        this.metroItem = {
          text: "ALL",
          value: null,
        };
      }
      if (this.$route.query.search) {
        this.searchText = this.$route.query.search;
      }
    },
    toggleCollapse: function (techLevel) {
      this.levelstatus[techLevel] = !this.levelstatus[techLevel];
      this.$forceUpdate();
    },
    bindData: function () {
      this.initMetroOptions();
      this.initSkillOptions();
      this.initCertificationOptions();
      this.initConsultants();
      this.initTechLevels();
      this.initProjects();
      this.initWorkTypes();
    },
    initConsultants: function () {
      db.collection("consultants")
        .get()
        .then((querySnapshot) => {
          this.consultants = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
        });
    },
    initTechLevels: function () {
      const levelArray = [
        {
          text: "ALL(Levels)",
          value: null,
        },
      ];
      db.collection("tech_levels")
        .get()
        .then((querySnapshot) => {
          this.techLevels = querySnapshot.docs.map((doc) => doc.data());
          this.techLevels.forEach((item) => {
            levelArray.push({
              text: item.name,
              value: item.name,
            });
          });
          this.levelOptions = levelArray;
          this.$forceUpdate();
        });
    },
    initMetroOptions: function () {
      const metroArray = [
        {
          text: "ALL(Metros)",
          value: null,
        },
      ];
      db.collection("metros")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((metro, index) => {
            metroArray.push({
              text: metro.name,
              value: metro.name,
            });
          });
          this.metroOptions = metroArray;
          this.$forceUpdate();
        });
    },
    initSkillOptions: function () {
      db.collection("skills")
        .get()
        .then((querySnapshot) => {
          this.skillOptions = [
            {
              text: "ALL(Skills)",
              value: null,
            },
          ].concat(
            querySnapshot.docs.map((doc) => ({
              text: doc.data().name,
              value: doc.data().name,
            }))
          );
          this.$forceUpdate();
        });
    },
    initCertificationOptions: function () {
      db.collection("certifications")
        .get()
        .then((querySnapshot) => {
          this.certificationOptions = [
            {
              text: "ALL(Certifications)",
              value: null,
            },
          ].concat(
            querySnapshot.docs.map((doc) => ({
              text: doc.data().description,
              value: doc.data().description,
            }))
          );
          this.$forceUpdate();
        });
    },
    initProjects: function () {
      const p1 = db.collection("gigs").get();
      const p2 = db.collection("companies").get();
      Promise.all([p1, p2]).then((res) => {
        let projects = res[0].docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const companies = res[1].docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.projectOptions = [];
        projects = projects.sort((a, b) => {
          return b.created - a.created;
        });
        projects.forEach((item) => {
          if (item.roles && item.roles.length > 0) {
            let companyName;
            if (item.company) {
              const company = companies.find((c) => c.id === item.company);
              if (company) {
                companyName = company.name;
              }
            }
            this.projectOptions.push({
              // text: "text",
              text: companyName ? `(${companyName}) ${item.title}` : item.title,
              value: item.id,
            });
            this.projectToRoles.set(
              item.id,
              item.roles.map((item) => ({
                text: item.title,
                value: item.id,
              }))
            );
          }
        });
      });
    },
    initWorkTypes: function () {
      db.collection("new_work_types")
        .get()
        .then((querySnapshot) => {
          this.workTypes = querySnapshot.docs.map((doc) => ({
            text: doc.data().name,
            value: false,
          }));
          this.notWorkTypes = querySnapshot.docs.map((doc) => ({
            text: doc.data().name,
            value: false,
          }));
          this.$forceUpdate();
        });
    },
    updateData: function () {
      if (this.consultants && this.techLevels) {
        this.data = {};
        this.techLevelsSort = this.techLevels.slice();
        this.techLevelsSort.sort((a, b) => {
          if (a.order === null || a.order === undefined) return 1;
          if (b.order === null || b.order === undefined) return -1;
          return a.order - b.order;
        });
        this.levelstatus = {};
        for (const i in this.techLevelsSort) {
          if (!this.data[this.techLevelsSort[i].name]) {
            this.data[this.techLevelsSort[i].name] = [];
            this.levelstatus[this.techLevelsSort[i].name] = true;
          }
        }
        this.data["general"] = [];
        this.levelstatus["general"] = true;
        for (const i in this.consultants) {
          if (this.consultants[i].created) {
            this.consultants[i].createdString = moment(
              this.consultants[i].created * 1000
            ).format("MM/DD/YYYY");
          }
          if (this.consultants[i].resume && this.consultants[i].resume.skills) {
            const skills = this.consultants[i].resume.skills;
            if (skills.indexOf("Windows OS") > -1)
              this.consultants[i].windows = true;
            if (skills.indexOf("Mac OS") > -1) this.consultants[i].mac = true;
            if (skills.indexOf("Linux OS") > -1)
              this.consultants[i].linux = true;
          }
          if (
            this.isActive === null ||
            !!this.consultants[i].is_active === !!this.isActive
          ) {
            if (
              !this.skillFilter ||
              (this.skillFilter &&
                this.consultants[i].resume &&
                this.consultants[i].resume.skills &&
                this.consultants[i].resume.skills.indexOf(this.skillFilter) >
                  -1)
            ) {
              if (
                !this.certificationFilter ||
                (this.certificationFilter &&
                  this.consultants[i].resume &&
                  this.consultants[i].resume.certifications &&
                  this.consultants[i].resume.certifications.some(
                    (item) => item.description === this.certificationFilter
                  ))
              ) {
                if (
                  !this.metroFilter ||
                  this.consultants[i].metro === this.metroFilter
                ) {
                  if (
                    !this.levelFilter ||
                    this.consultants[i].tech_level === this.levelFilter
                  ) {
                    if (
                      !this.workTypeFilter ||
                      this.hasWorkType(
                        this.consultants[i].work_type,
                        this.workTypeFilter
                      )
                    ) {
                      if (
                        !this.notWorkTypeFilter ||
                        this.hasNotWorkType(
                          this.consultants[i].work_type,
                          this.notWorkTypeFilter
                        )
                      ) {
                        if (
                          !this.searchFilter ||
                          JSON.stringify(this.consultants[i])
                            .toLowerCase()
                            .indexOf(this.searchFilter.toLowerCase()) > -1
                        ) {
                          if (
                            this.verified === undefined ||
                            this.verified === null ||
                            this.verified === this.consultants[i].verified
                          ) {
                            if (this.consultants[i].tech_level) {
                              if (this.data[this.consultants[i].tech_level]) {
                                this.data[this.consultants[i].tech_level].push(
                                  this.consultants[i]
                                );
                              }
                            } else {
                              this.data["general"].push(this.consultants[i]);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        Object.keys(this.data).forEach((item) => {
          this.data[item].sort((a, b) => {
            if (a.verified !== b.verified) {
              if (a.verified) return -1;
              if (b.verified) return 1;
            }
            if (!a.created) return 1;
            if (!b.created) return -1;
            return b.created - a.created;
          });
        });
      }
    },
    onFilter: function (data) {
      this.metroFilter = data.metro;
      this.certificationFilter = data.certification;
      this.skillFilter = data.skill;
      this.levelFilter = data.level;
      this.searchFilter = data.search;
      this.workTypes = JSON.parse(JSON.stringify(data.workTypes));
      this.workTypeFilter = data.workTypes
        .filter((item) => item.value)
        .map((item) => item.text)
        .join(",");
      this.notWorkTypes = JSON.parse(JSON.stringify(data.notWorkTypes));
      this.notWorkTypeFilter = data.notWorkTypes
        .filter((item) => item.value)
        .map((item) => item.text)
        .join(",");
      this.verified = data.verified;
      this.isActive = data.isActive;
      this.updateData();
    },
    hasWorkType: function (workType, workTypeFilter) {
      if (!workTypeFilter) return true;
      if (!workType) return false;
      const workTypeArray = workType.split(",");
      const workTypeFilterArray = workTypeFilter.split(",");
      let returnValue = false;
      returnValue = workTypeFilterArray.every((item) => {
        return workTypeArray.indexOf(item) > -1;
      });
      return returnValue;
    },
    hasNotWorkType: function (workType, notWorkTypeFilter) {
      if (!notWorkTypeFilter) return true;
      if (!workType) return false;
      const workTypeArray = workType.split(",");
      const notWorkTypeFilterArray = notWorkTypeFilter.split(",");
      let returnValue = false;
      returnValue = notWorkTypeFilterArray.every((item) => {
        return workTypeArray.indexOf(item) <= -1;
      });
      return returnValue;
    },
    viewAsConsultant: function (data) {
      const routeData = this.$router.resolve({
        path: "/home/admin/consultant_review",
        query: { id: data.id },
      });
      window.open(routeData.href, "_blank");
    },
    openEditPannel: function (action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPannel: function () {
      this.editOpen = false;
    },
    onClickRequest: function (data) {
      this.requestPropsData = {
        clientEmail: this.clientEmail ? this.clientEmail : null,
        techEmail: data.email ? data.email : null,
        techName: data.name ? data.name : null,
      };
      this.openEditPannel(1, true);
    },
    onRequestButtonClick: function (data) {
      this.requestSubmitLoading = true;
      httpGetNoToken("create_request", data)
        .then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "create success",
            });
            this.closeEditPannel();
          } else {
            this.$toasted.global.toast_error({
              message: "create error",
            });
          }
        })
        .finally(() => {
          this.requestSubmitLoading = false;
        });
    },
    onClickProject: function (data) {
      if (data && data.id) {
        this.editConsultantId = data.id;
        this.openEditPannel(2, true);
        this.addType = "one";
      }
    },
    addAll: function (data) {
      this.openEditPannel(2, true);
      this.addType = "all";
    },
    toPublic: function () {
      const data = {
        metro: this.metroFilter,
        certification: this.certificationFilter,
        skill: this.skillFilter,
        level: this.levelFilter,
        search: this.searchFilter,
        worktypes: this.workTypeFilter,
        verified: this.verified,
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        "scaledesk"
      ).toString();
      const routeData = this.$router.resolve({
        path: "/public/available_techs/allinfo",
        query: { code: encrypted },
      });
      window.open(routeData.href, "_blank");
    },
    onProjectButtonClick: async function (data) {
      let send_sms = true;
      let consultants = [];
      if (this.addType === "all") {
        Object.keys(this.data).forEach((item) => {
          this.data[item].forEach((c) => {
            consultants.push(c.id);
          });
        });
      } else if (this.addType === "one") {
        consultants.push(this.editConsultantId);
      }
      if (consultants.length === 0) {
        return;
      }
      if (data.editProjectId && data.editRoleId) {
        this.projectSubmitLoading = true;
        // consultants.forEach(async (ct) => {
        for (const i in consultants) {
          const ct = consultants[i];
          const projectResult = await database.getDoc(
            "gigs",
            data.editProjectId
          );
          const project = projectResult.data.data;
          let selectedConsultants;
          if (project) {
            if (project.selected_consultants) {
              selectedConsultants = JSON.parse(
                JSON.stringify(project.selected_consultants)
              );
              const selectedConsultant = selectedConsultants.find(
                (item) => item.role_id === data.editRoleId
              );
              if (selectedConsultant) {
                const targetConsultant = selectedConsultant.consultants.find(
                  (item) => item.id === ct
                );
                if (!targetConsultant) {
                  selectedConsultant.consultants.push({
                    id: ct,
                    status: "Added",
                  });
                } else {
                  send_sms = false;
                }
              } else {
                selectedConsultants.push({
                  role_id: data.editRoleId,
                  consultants: [
                    {
                      id: ct,
                      status: "Added",
                    },
                  ],
                });
              }
            } else {
              selectedConsultants = [];
              selectedConsultants.push({
                role_id: data.editRoleId,
                consultants: [
                  {
                    id: ct,
                    status: "Added",
                  },
                ],
              });
            }
            const result = await database.updateDocById(
              "gigs",
              data.editProjectId,
              {
                selected_consultants: selectedConsultants,
              }
            );
            this.projectSubmitLoading = false;
            if (result.ok) {
              if (send_sms) {
                const smsResult = await httpGet(
                  "send_consultant_project_message",
                  {
                    projectId: data.editProjectId,
                    roleId: data.editRoleId,
                    consultantId: ct,
                  }
                );
                if (smsResult.ok) {
                  this.$toasted.global.toast_success({
                    message: "sms success",
                  });
                  this.$emit("closePanel");
                } else {
                  this.$toasted.global.toast_error({
                    message: smsResult.message,
                  });
                }
              } else {
                this.$emit("closePanel");
              }
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          }
        }
        this.$toasted.global.toast_success({
          message: "success",
        });
        this.projectSubmitLoading = false;
        this.closeEditPannel();
      } else {
        this.$toasted.global.toast_error({
          message: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.os-icon {
  opacity: 0.4;
  margin-right: 4px;
}
</style>
